import gsap from 'gsap'


function initMarq(){
    if(window.isMobile){
        gsap.fromTo('.marq__images',{
            x: -600
        }, {
            x:200,
            scrollTrigger: {
                trigger: '.marq',
                scroller: '.scrollContainer',
                scrub: true,
                start: "top bottom",
                end: "bottom top"
            }
        })
    
        gsap.fromTo('.marq__text',{
            x: 1200,
        },{
            x: -800,
            scrollTrigger: {
                trigger: '.marq',
                scroller: '.scrollContainer',
                scrub: true,
                start: "top bottom",
                end: "bottom top"
            }
        })
    }
}

if(document.querySelector('.marq')){
    initMarq();
}
